/**
 * A small "i" badge that reveals a field's explanation on hover/focus.
 *
 * Uses the native `title` attribute (no extra JS popover), matching the
 * hover-tooltip convention already used on chips and callouts elsewhere in
 * this app - `tabIndex` and `aria-label` keep it reachable without a mouse.
 */
export function InfoTip({ text }: { text?: string | null }) {
  if (!text) return null
  return (
    <span className="info-tip" tabIndex={0} title={text} aria-label={text} role="note">
      i
    </span>
  )
}
